import React, { useEffect, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import axios from "../../axios";
import api from "../../api"
import Button from '@mui/material/Button';
import {DesktopDatePicker} from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Stack from '@mui/material/Stack';
import moment from 'moment';
import CatalogCourseFilter from "../../Components/Filters/CatalogCourseFilter"
import AffiliateEducatorPaymentExport from './AffiliateEducatorPaymentExport';
import SubscriptionFilter from "../../Components/Filters/SubscriptionFilter"
import EducatorSkeleton from './skeleton/EducatorSkeleton';
const Item = styled('div')(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AffiliatePaymentEducator() {

    const [loading, setLoading] = useState(true);
    const [token, settoken] = useState(localStorage.getItem("user"));
    const [Coupons, setCoupons] = useState([])
    const [filteredCoupons, setFilteredCoupons] = useState([]);
    const [seacrhCode, setSearchCode] = useState('');
    const [selectedCode, setSelectedCode] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false);
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [dueAmount, setDueAmount] = useState(null);
    const [showCoupon, setShowCoupon] = useState([]);
    const [selectedSubscription, setSelectedSubscription] = useState('')
    const [selectedCourse, setSelectedCourse] = useState('')

    useEffect(() => {
        const fetchEducatorCoupon = async () => {
            try {
                const response = await axios.get(api.getEducatorCoupon, {
                    method: 'GET',
                    headers: {
                        "x-auth-token": token,
                    }
                });
                var codeList = response.data?.map(function (item) {
                    return item['code'];
                });
                codeList.unshift('ALL');
                setCoupons(codeList);
                setLoading(false);
            } catch (error) {
                console.warn(error);
            }
        }
        fetchEducatorCoupon();
    }, [])

    const SeacrhCoupon = async (value) => {
        const filterSearchItems = Coupons.filter(item=>item.toLowerCase().includes(value.toLowerCase()));
        setFilteredCoupons(filterSearchItems)
        setIsFiltered(true)
    }

    const handleinputCode = (e) => {
        setSearchCode(e.target.value);
        if (e.target.value) {
            if (e.target.value.length % 2 == 0) {
                SeacrhCoupon(e.target.value)
            }
        }
        if (!e.target.value) {
            setFilteredCoupons([]);
            setIsFiltered(false)
        }
    }
    const handleSelectCode = (event, value) => {
        if (value.length > 0) {
            if (value.includes('ALL') && value.length == 1) {
                setShowCoupon(['ALL'])
                setSelectedCode(Coupons)
            } else if (value.includes('ALL') && value.length > 1) {
                if (value[value.length - 1] == 'ALL') {
                    setSelectedCode(Coupons);
                    setShowCoupon(['ALL'])
                } else {
                    const removeItem = value.filter(item => item != 'ALL')
                    const codeList = selectedCode.filter(item => item != removeItem[0]);
                    setSelectedCode(codeList);
                }
            } else {
                setShowCoupon(value)
                setSelectedCode(value)
            }
        } else {
            setShowCoupon(value)
            setSelectedCode([])
            setSearchCode("")
            setIsFiltered(false)
        }
        setIsFiltered(false)
    }
    const fetchDueData = async () => {
        let body ={
            coupon: [...selectedCode]
        }
        if(startTime && endTime){
            body.startTime = moment(startTime).startOf('day').utc()
            body.endTime = moment(endTime).endOf('day').utc()
          }
        const response = await axios.post(api.affiliateSearchDue, body, {
            headers: {
                "x-auth-token": token,
                'Content-Type': 'application/json',
            }
        });
        if (response.data[0]) {
            setDueAmount(response.data[0].totalEarnings)
        } else {
            setDueAmount("")
        }
    }

    const handleGetDueData = () => {
        fetchDueData();
    }

    const handleResetData = () => {
        //reset all items
        setSelectedCode([])
        setShowCoupon([])
        setStartTime(null)
        setEndTime(null)
        setDueAmount("")
        setSelectedSubscription("")
        setSelectedCourse("")
    }

    const subscriptionSelector = (
      <Box sx={{ ml: -2 }}>
        <SubscriptionFilter
          selectedSubscription={selectedSubscription}
          handleSubscriptionSelection={(subscriptionId) => {
            setSelectedSubscription(subscriptionId);
          }}
        />
      </Box>
    );

    const catalogCourseSelector = (
        <CatalogCourseFilter
            selectedCourse={selectedCourse}
            handleCourseSelection={(courseId) => {
                setSelectedCourse(courseId)
            }}
        />
    )

    return (
        <>
            {
                loading ? <EducatorSkeleton/>
                    :
                    <Box sx={{ maxWidth: '500px' }}>
                        <Stack justifyContent={'center'} alignItems={'center'} spacing={3}>
                         {catalogCourseSelector}
                         {subscriptionSelector}
                        </Stack>
                        <Grid sx={{mt: 2}} container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={12}>
                                <Item>
                                    <Autocomplete
                                        value={showCoupon}
                                        onChange={handleSelectCode}
                                        multiple
                                        id="checkboxes-tags-demo"
                                        options={isFiltered ? filteredCoupons : Coupons.slice(0, 200)}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option}
                                        renderOption={(props, option, { selected }) => {
                                            return (
                                                <li {...props}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selectedCode.includes(option) ? true : false}
                                                    />
                                                    {option ? option : null}
                                                </li>
                                            )
                                        }}
                                        style={{ width: '100%' }}
                                        renderInput={(params) => (
                                            <TextField {...params} value={seacrhCode} onChange={handleinputCode} label="Select Coupons" placeholder="Favorites" />
                                        )}
                                    />
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <Stack spacing={3}>
                                            <DesktopDatePicker
                                                label="START DATE"
                                                inputFormat="MM/dd/yyyy"
                                                value={startTime ? startTime : ""}
                                                onChange={(newValue) => setStartTime(newValue)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />

                                        </Stack>
                                    </LocalizationProvider>
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <Stack spacing={3}>
                                            <DesktopDatePicker
                                                label="End Date"
                                                inputFormat="MM/dd/yyyy"
                                                value={endTime ? endTime : ""}
                                                onChange={(newValue) => setEndTime(newValue)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                    
                                </Item>
                            </Grid>

                            <Grid item xs={6}>
                                <Item>
                                    <Button disabled onClick={handleGetDueData} variant="contained">Search</Button>
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <Button onClick={handleResetData} color="secondary" variant="contained">Reset</Button>
                                </Item>
                            </Grid>

                            <Grid item xs={12}>
                                <Item>
                                    <h2> Total Due : {Number(dueAmount).toFixed(2)} </h2>
                                </Item>
                            </Grid>

                            <Grid item xs={12}>
                                <Item>
                                    <AffiliateEducatorPaymentExport
                                        selectedCode={selectedCode}
                                        payment={dueAmount}
                                        fileName="Affiliate payment"
                                        startTime={startTime}
                                        endTime={endTime}
                                        courseId={selectedCourse}
                                        subscriptionId={selectedSubscription}
                                    />
                                </Item>
                            </Grid>

                        </Grid>
                    </Box>
            }
        </>
    );
}
